import React from 'react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import redirectToCartOperation from 'store/app/operation/redirectToCartOperation';
import styles from './CheckoutButton.module.scss';

const CheckoutButton = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const closePopup = () => {
    dispatch(redirectToCartOperation());
  };

  return (
    <button id="checkout-button" className={cn(styles.checkoutButton)} onClick={() => closePopup()}>
      <span>{t('txt_checkout')}</span>
    </button>
  );
};

export default CheckoutButton;
